import GptAd, { GptAdProps } from "./GptAd";
import styles from "./HomepageTopInjectorMobile.module.scss";
import cx from "classnames";

const HomepageTopInjectorMobileAd = ({ className, ...props }: GptAdProps) => {
  return (
    <GptAd
      className={cx(className, styles.root)}
      format="injector"
      sizesAt0="mobile-wide"
      sizesAt976=""
      targetingPos="mobileboxpremium"
      {...props}
    />
  );
};

export default HomepageTopInjectorMobileAd;
